
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";

@Component({
  name: "Content",
})
export default class extends Vue {
  currentParent!: string;

  @Watch("$route", { immediate: true })
  onRouteChange(route: Route) {
    this.currentParent = (this.$route.matched[1]?.parent as any).name || "";
    this.clearScoll();
  }

  // 清除滚动条状态
  clearScoll() {
    const ref = this.$refs.ref_content_body as any;
    if (ref) {
      ref.scrollTop = 0;
    }
  }
}
